import React from 'react';
import { ChevronLeft, ChevronRight, Clock } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

export default function SchedulePage() {
  const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'];
  const times = ['09:00 AM', '10:00 AM', '11:00 AM', '12:00 PM', '01:00 PM', '02:00 PM', '03:00 PM'];
  
  const events = [
    { day: 0, start: 0, duration: 1.5, title: "Adv Math", room: "302", color: "bg-blue-100 text-blue-700 border-blue-200" },
    { day: 0, start: 3, duration: 1, title: "Lunch", room: "Cafeteria", color: "bg-gray-100 text-gray-600 border-gray-200" },
    { day: 0, start: 5, duration: 1.5, title: "Physics", room: "Lab 1", color: "bg-purple-100 text-purple-700 border-purple-200" },
    
    { day: 1, start: 1, duration: 1.5, title: "Chemistry", room: "Lab 2", color: "bg-green-100 text-green-700 border-green-200" },
    { day: 1, start: 3, duration: 1, title: "Lunch", room: "Cafeteria", color: "bg-gray-100 text-gray-600 border-gray-200" },
    
    { day: 2, start: 0, duration: 1.5, title: "Adv Math", room: "302", color: "bg-blue-100 text-blue-700 border-blue-200" },
    { day: 2, start: 4, duration: 1.5, title: "History", room: "104", color: "bg-orange-100 text-orange-700 border-orange-200" },
    
    { day: 3, start: 1, duration: 1.5, title: "Chemistry", room: "Lab 2", color: "bg-green-100 text-green-700 border-green-200" },
    { day: 3, start: 3, duration: 1, title: "Lunch", room: "Cafeteria", color: "bg-gray-100 text-gray-600 border-gray-200" },
    { day: 3, start: 5, duration: 1, title: "Staff Mtg", room: "Conf A", color: "bg-red-100 text-red-700 border-red-200" },
    
    { day: 4, start: 0, duration: 1.5, title: "Adv Math", room: "302", color: "bg-blue-100 text-blue-700 border-blue-200" },
    { day: 4, start: 2, duration: 1, title: "Gym", room: "Gym", color: "bg-yellow-100 text-yellow-700 border-yellow-200" },
  ];

  return (
    <div className="space-y-8 h-[calc(100vh-8rem)] flex flex-col">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 flex-none">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Weekly Schedule</h1>
          <p className="text-muted-foreground mt-1">October 24 - October 28, 2025</p>
        </div>
        <div className="flex items-center gap-2">
          <Button variant="outline" size="icon">
            <ChevronLeft className="h-4 w-4" />
          </Button>
          <Button variant="outline">Today</Button>
          <Button variant="outline" size="icon">
            <ChevronRight className="h-4 w-4" />
          </Button>
          <div className="w-px h-6 bg-border mx-2"></div>
          <Button>Add Event</Button>
        </div>
      </div>

      <Card className="flex-1 overflow-hidden flex flex-col shadow-md border-none">
        <div className="grid grid-cols-6 border-b flex-none">
          <div className="p-4 border-r bg-muted/30 text-center text-sm font-medium text-muted-foreground">Time</div>
          {days.map((day, i) => (
            <div key={i} className="p-4 text-center border-r last:border-r-0 font-semibold">
              {day}
              <div className={`mx-auto mt-1 h-8 w-8 rounded-full flex items-center justify-center text-sm ${i === 0 ? 'bg-primary text-primary-foreground' : ''}`}>
                {24 + i}
              </div>
            </div>
          ))}
        </div>
        
        <div className="overflow-y-auto flex-1">
          <div className="grid grid-cols-6 min-h-[600px] relative">
             {/* Grid Lines */}
            <div className="col-span-6 absolute inset-0 grid grid-rows-7 pointer-events-none">
              {times.map((_, i) => (
                <div key={i} className="border-b border-dashed border-muted w-full h-full"></div>
              ))}
            </div>

            {/* Time Labels */}
            <div className="border-r bg-muted/5 relative z-10">
              {times.map((time, i) => (
                <div key={i} className="h-[14.28%] p-2 text-xs text-muted-foreground text-center font-medium flex items-start justify-center pt-4">
                  {time}
                </div>
              ))}
            </div>

            {/* Days Columns */}
            {days.map((_, dayIndex) => (
              <div key={dayIndex} className="border-r last:border-r-0 relative h-full">
                {events.filter(e => e.day === dayIndex).map((event, i) => (
                  <div 
                    key={i}
                    className={`absolute left-1 right-1 p-2 rounded-md border text-xs font-medium shadow-sm hover:shadow-md transition-all cursor-pointer ${event.color}`}
                    style={{
                      top: `${(event.start / 7) * 100}%`,
                      height: `${(event.duration / 7) * 100}%`,
                    }}
                  >
                    <div className="flex items-center gap-1 mb-1 font-bold">
                      <Clock className="h-3 w-3" />
                      {/* Approximate time calc logic simplified for demo */}
                      {times[event.start].split(' ')[0]}
                    </div>
                    <div className="font-bold text-sm mb-0.5 truncate">{event.title}</div>
                    <div className="opacity-80 truncate">{event.room}</div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </Card>
    </div>
  );
}
